import VenueLocation from './VenueLocation'
export default VenueLocation